
















import { Component, Prop, Vue } from 'vue-property-decorator';
import { ValidationProblemDetails } from 'performo-api';

@Component({ components: {} })
export default class ValidationErrors extends Vue {
  @Prop({ required: true })
  private validationProblems!: ValidationProblemDetails;

  private async mounted() {
    // blank
  }
}
